/**
 * Embryo Transfer Outcome API Endpoints
 * Base URL: /api/v1/embryo-outcomes
 */

export class EmbryoOutcomeAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * Create new Embryo Outcome
   * POST /api/v1/embryo-outcomes
   */
  async createEmbryoOutcome(payload) {
    return this.apiClient.post('/api/v1/embryo-outcomes', payload);
  }

  /**
   * Get Embryo Outcome by ID
   * GET /api/v1/embryo-outcomes/:outcomeId
   */
  async getEmbryoOutcome(outcomeId) {
    return this.apiClient.get(`/api/v1/embryo-outcomes/${outcomeId}`);
  }

  /**
   * Get all Embryo Outcomes for a Procedure
   * GET /api/v1/embryo-outcomes/procedure/:procedureId
   */
  async getEmbryoOutcomesByProcedure(procedureId) {
    return this.apiClient.get(
      `/api/v1/embryo-outcomes/procedure/${procedureId}`,
    );
  }

  /**
   * Update Embryo Outcome
   * PUT /api/v1/embryo-outcomes/:outcomeId
   */
  async updateEmbryoOutcome(outcomeId, payload) {
    return this.apiClient.put(
      `/api/v1/embryo-outcomes/${outcomeId}`,
      payload,
    );
  }

  /**
   * Delete Embryo Outcome (soft delete)
   * DELETE /api/v1/embryo-outcomes/:outcomeId
   */
  async deleteEmbryoOutcome(outcomeId) {
    return this.apiClient.delete(`/api/v1/embryo-outcomes/${outcomeId}`);
  }
}
